import { loadAndMigrateState, Migrator } from '@ps20-frontend/migrations';
import { IAppState } from '../localStore';
import { effectiveZaehlstueck } from './9_effective_zaehlstueck';
import { sicherungsglaeubiger } from './10_sigl';
import { fevorvertragsnummer } from './11_fevorvertragsnummer_implementieren';
import { vorversicherungDataChanged } from './12_vorversicherungData_changed';
import { zahlungBusinessformChanged } from './13_zahlung_businessform_changed';
import { migrateAssekuranztarif } from './14_migrate_assekuranztarif';
import { migrateVermittlernummer } from './15_migrate_vermittlernummer';
import { migrateVorversicherung } from './16_migrate_vorversicherung';
import { migrateZahlung } from './17_migrate_zahlung';
import { migrateVhvCheckoutProdukt } from './18_migrate_vhv_produkt';
import { migrateProduktId } from './19_migrate_produktId';
import { migrateHoeherwertigerHausrat } from './20_migrate_hoeherwertigerhausrat_files';
import { migrateRassen } from './21_migrate_rasse';
import { migrateRassePyrenaeen } from './22_migrate_rasse_pyrenaeen';
import { migrateProduktBreedLabel } from './23_migrate_produkt_breed_label';
import { migrateDiagnosisLabel } from './24_migrate_diagnosis_label';
import { migrateVorversichererAllianz } from './25_migrate_vorversicherer_allianz';
import { migrateCheckoutUwContexts } from './26_migrate_uw_contexts';
import { migrateCheckoutUwEntriesRequired } from './27_migrate_uw_entries_required';
import { migrateDiagnosisCodes } from './28_migrate_diagnosis_codes';
import { migrateVnWechselgrundTkv } from './29_migrate_vn_wechselgrund_tkv';

export const stateMigrators: Migrator[] = [
  {
    toVersion: 9,
    migratorFunction: effectiveZaehlstueck,
  },
  {
    toVersion: 10,
    migratorFunction: sicherungsglaeubiger,
  },
  {
    toVersion: 11,
    migratorFunction: fevorvertragsnummer,
  },
  {
    toVersion: 12,
    migratorFunction: vorversicherungDataChanged,
  },
  {
    toVersion: 13,
    migratorFunction: zahlungBusinessformChanged,
  },
  {
    toVersion: 14,
    migratorFunction: migrateAssekuranztarif,
  },
  {
    toVersion: 15,
    migratorFunction: migrateVermittlernummer,
  },
  {
    toVersion: 16,
    migratorFunction: migrateVorversicherung,
  },
  {
    toVersion: 17,
    migratorFunction: migrateZahlung,
  },
  {
    toVersion: 18,
    migratorFunction: migrateVhvCheckoutProdukt,
  },
  {
    toVersion: 19,
    migratorFunction: migrateProduktId,
  },
  {
    toVersion: 20,
    migratorFunction: migrateHoeherwertigerHausrat,
  },
  {
    toVersion: 21,
    migratorFunction: migrateRassen,
  },
  {
    toVersion: 22,
    migratorFunction: migrateRassePyrenaeen,
  },
  {
    toVersion: 23,
    migratorFunction: migrateProduktBreedLabel,
  },
  {
    toVersion: 24,
    migratorFunction: migrateDiagnosisLabel,
  },
  {
    toVersion: 25,
    migratorFunction: migrateVorversichererAllianz,
  },
  {
    toVersion: 26,
    migratorFunction: migrateCheckoutUwContexts,
  },
  {
    toVersion: 27,
    migratorFunction: migrateCheckoutUwEntriesRequired,
  },
  {
    toVersion: 28,
    migratorFunction: migrateDiagnosisCodes,
  },
  {
    toVersion: 29,
    migratorFunction: migrateVnWechselgrundTkv,
  },
];

export const loadAndMigrateCheckoutState = (
  currentState: IAppState,
  loadedState: { version: number },
) => loadAndMigrateState(currentState, loadedState, stateMigrators);
